import { PaymentMethod } from './usePaymentMethods';

/**
 * Mollie-hosted method logo. Decorative on purpose: every call site renders the
 * method name as text next to it, so announcing the image would just repeat it.
 *
 * Uses Mollie's own url rather than components/Mollie/PaymentMethodIcon, whose local
 * SVG set is incomplete (no alma/blik/twint/…) and mismatched on case (Przelewy24).
 */
export default function PaymentMethodLogo({ method }: { method: PaymentMethod }) {
    if (!method.image) return null;

    return <img src={method.image} alt="" aria-hidden className="tw-h-6 tw-w-auto tw-shrink-0" />;
}
